import type { SvgIconProps } from './types';

export function BiCookie(props: SvgIconProps) {
  return (
    <svg stroke="currentColor" fill="currentColor" strokeWidth={0} viewBox="0 0 24 24" height="1em" width="1em" {...props}>
      <path d="M21.598,11.064c-0.243-0.184-0.557-0.247-0.854-0.172C20.458,10.966,20.222,11,20,11c-1.654,0-3-1.346-3.003-2.937 c0.005-0.034,0.016-0.136,0.017-0.17c0.013-0.317-0.126-0.621-0.373-0.819c-0.248-0.199-0.575-0.271-0.881-0.187 C15.467,6.964,15.226,7,15,7c-1.654,0-3-1.346-3-3c0-0.217,0.031-0.444,0.099-0.716c0.078-0.315-0.002-0.648-0.214-0.894 c-0.211-0.245-0.518-0.369-0.853-0.342C5.883,2.544,2,6.822,2,12c0,5.514,4.486,10,10,10s10-4.486,10-10 c0-0.049-0.003-0.097-0.007-0.16C21.986,11.535,21.841,11.249,21.598,11.064z M12,20c-4.411,0-8-3.589-8-8 c0-3.723,2.509-6.864,6.006-7.75C10.137,6.892,12.327,9,15,9c0.033,0,0.066,0,0.101-0.001c0.46,2.26,2.449,3.971,4.837,4 C19.444,16.941,16.073,20,12,20z" />
      <circle cx={12.5} cy={11.5} r={1.5} />
      <circle cx={8.5} cy={8.5} r={1.5} />
      <circle cx={7.5} cy={12.5} r={1.5} />
      <circle cx={15.5} cy={15.5} r={1.5} />
      <circle cx={10.5} cy={16.5} r={1.5} />
    </svg>
  );
}
